export const CHANNEL_ID = 'betting';
export const DEPOSIT_NORMAL_TYPE = 'DEPOSIT';

export const SCROLL_DELTA = 25;
export const HEADER_HEIGHT = 44;
